import { render, staticRenderFns } from "./mstrbudgetadditionfrm.vue?vue&type=template&id=5fd1a8be"
import script from "./mstrbudgetadditionfrm.vue?vue&type=script&lang=js"
export * from "./mstrbudgetadditionfrm.vue?vue&type=script&lang=js"
import style0 from "./mstrbudgetadditionfrm.vue?vue&type=style&index=0&id=5fd1a8be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports